import { useQuery } from "@tanstack/react-query";
import api from "../../../../../services/api";
import { UploadSourcesList } from "../@types/UploadSource";

const useUploadsData = (hashValue: string) => {
  const { data: uploadsData } = useQuery({
    queryKey: ["uploadsData", hashValue],
    queryFn: () => api.uploadsData(hashValue),
    enabled: Boolean(hashValue),
    select: response => response.data.uploads_data || []
  });

  return {
    data: uploadsData as UploadSourcesList
  };
};

export default useUploadsData;
